import { store } from '../../../config/configureStore';
import { getClientPortalService } from '../../../config/configureClientPortalApi';
import { AxiosInstance } from 'axios';

interface AndroidVersionResponse {
  data?: {
    minimumVersion: string;
    latestVersion: string;
  };
  error?: boolean;
}

const mockMinVersionAndroid = {
  minimumVersion: '1.8.8',
  latestVersion: '1.8.8',
};

export const getMinVersionAndroid = async (): Promise<AndroidVersionResponse> => {
  const api: AxiosInstance = getClientPortalService();
  const { config } = store.getState();
  if (config.useMock) {
    return { data: { minimumVersion: mockMinVersionAndroid.minimumVersion, latestVersion: mockMinVersionAndroid.latestVersion } };
  }
  try {
    const response = await api.get(config.endpoints.minVersionAndroid);
    const versionResponse = response as AndroidVersionResponse;
    return { data: { minimumVersion: versionResponse.data.minimumVersion, latestVersion: versionResponse.data.latestVersion } };
  } catch (e) {
    console.error('getMinVersionAndroidError', e);
    return { error: true };
  }
};
